import React from "react";
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from "react-router-dom";
import { Layout, Menu, Button } from "antd";
import { DashboardOutlined, FileSearchOutlined, UserOutlined } from "@ant-design/icons";

import InvoiceCheck from "./components/Dashboard/Dashboard"; // Rechnungsprüfung Komponente
import SupplierList from "./components/List/SupplierList"; // Lieferanten Komponente

const { Header, Content } = Layout;

const App = () => {
    return (
        <Router>
            <Layout style={{ minHeight: "100vh" }}>
                {/* Header für das obere Menü */}
                <Header style={{ position: "fixed", width: "100%", zIndex: 1, background: "#001529" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ color: "#fff", fontSize: "20px", fontWeight: "bold" }}>
                            LeBurger InvoiceApp
                        </div>

                        <Menu theme="dark" mode="horizontal" defaultSelectedKeys={["2"]} style={{ flex: 1 }}>
                            <Menu.Item key="1" icon={<DashboardOutlined />}>
                                <Link to="/">Dashboard</Link>
                            </Menu.Item>
                            <Menu.Item key="2" icon={<FileSearchOutlined />}>
                                <Link to="/invoice-check">Rechnungsprüfung</Link>
                            </Menu.Item>
                            <Menu.Item key="3" icon={<UserOutlined />}>
                                <Link to="/suppliers">Lieferanten</Link>
                            </Menu.Item>
                        </Menu>

                        <Button type="primary" style={{ marginLeft: "10px" }}>Login</Button>
                    </div>
                </Header>

                {/* Content */}
                <Layout style={{ marginTop: "64px" }}>
                    <Content style={{ padding: "24px", minHeight: "100%" }}>
                        <Routes>
                            {/* ⬇️ Automatische Weiterleitung von "/" auf "/invoice-check" */}
                            <Route path="/" element={<Navigate to="/invoice-check" replace />} />
                            <Route path="/invoice-check" element={<InvoiceCheck />} />
                            <Route path="/suppliers" element={<SupplierList />} />
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </Router>
    );
};

export default App;
